const statusColor = {
  Approved: '#2db731',
  Active: '#2db731',
  Assigned: '#2db731',
  Awarded: '#2db731',
  Confirmed: '#2db731',
  Delivered: '#2db731',
  Open: '#2db731',
  Paid: '#2db731',
  completed: '#2db731',
  Latest: '#2db731',
  Issued: '#2db731',
  Available: '#2db731',
  Locked: '#ff0802',
  Archived: '#ff0802',
  Cancelled: '#ff0802',
  Closed: '#ff0802',
  Declined: '#ff0802',
  Rejected: '#ff0802',
  Changed: '#ff0802',
  Opportunity: '#b713a6',
  Revised: '#fbff14',
  Update: '#fbff14',
  Expired: '#fbff14',
  'Quote Expired': '#fbff14',
  Held: '#ffbe29',
  Credited: '#ffbe29',
  Escalated: '#ffbe29',
  Draft: '#ff9d00',
  Scheduled: '#ff9d00',
  'In Repair': '#ff9d00',
  New: '#1516ff',
  Quoted: '#1516ff',
  'New Lead': '#1516ff',
  Pending: '#1516ff',
  Resubmitted: '#1516ff',
  Submitted: '#1516ff',
}
const stateColor = {
  Inactive: '#b7b7b5',
  Active: '#2db731',
  Terminated: '#ff0802',
  Suspended: '#fbff14',
}
const staffStatusColor = {
  inactive: '#b7b7b5',
  active: '#2db731',
  break: '#fbff14',
  'lunch-break': '#fbff14',
  timeout: '#ff9d00',
}
const leaveTypeColor = {
  AL: '#30628e',
  MC: '#ff9d00',
  CL: '#4ab77a',
}
module.exports = {
  apiUrl: process.env.REACT_APP_FOXX_API,
  streamUrl: process.env.REACT_APP_STREAM_API,
  web_page_prefix: process.env.REACT_APP_WEB_PAGE_PREFIX,
  statusColor,
  stateColor,
  leaveTypeColor,
  staffStatusColor,
}
